import { handleActions } from 'redux-actions';
import {
  metaSiteInsideAppsFetchInitialized,
  metaSiteInsideAppsFetchSucceeded,
  metaSiteInsideAppsFetchFailed,
} from '../../../MetaSites';
import { MetaSiteApp } from '../../../interfaces';

const isUnderMetaSiteSettingsRoute = new RegExp('/meta-sites/(.*)/settings/(.*)');

interface MetaSitesInsideAppsState {
  isLoading: boolean
  failed: boolean
  list: MetaSiteApp[]
  total: number
}

const initialState: MetaSitesInsideAppsState = {
  isLoading: false,
  list: [],
  total: 0,
  failed: false,
};

const reducer = handleActions<MetaSitesInsideAppsState, any>({
  [metaSiteInsideAppsFetchInitialized.toString()]: state => ({
    ...state,
    failed: false,
    isLoading: true,
  }),
  [metaSiteInsideAppsFetchSucceeded.toString()]: (state, { payload }) => ({
    ...state,
    isLoading: false,
    list: payload.data,
    total: payload.meta.total,
  }),
  [metaSiteInsideAppsFetchFailed.toString()]: state => ({
    ...state,
    failed: true,
    isLoading: false,
  }),
  '@@router/LOCATION_CHANGE': (state, { payload }) => {
    if (!isUnderMetaSiteSettingsRoute.test(payload.location.pathname)) {
      return initialState;
    }

    return {
      ...state,
    };
  },
}, initialState);

export default reducer;
